import { render } from "./Bienvenida.vue?vue&type=template&id=192a21ac"
import script from "./Bienvenida.vue?vue&type=script&lang=js"
export * from "./Bienvenida.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Fam. Pariona\\Documents\\Programación\\capitaltrabajo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__